import  crmVideo from "./Assets/CRMHUB.mp4";
import  govVideo from "./Assets/GovDataLake.mp4";
import  sacredAdminVideo from "./Assets/SacredHours-Admin.mp4";
import  sacredIosVideo from "./Assets/SacredHours-IOS.mp4";
import  sacredAndroidVideo from "./Assets/SacredHours-IOS.mp4";
import  energyVideo from "./Assets/SacredHours-IOS.mp4";

export const data = [
  {
    id: "1",
    title: "Sacred Hours – Admin Panel",
    video: sacredAdminVideo,
    description : "Sacred Hours Admin is a production-based backend system that manages content and user data for the Sacred Hours religious mobile application. The admin panel controls user information, devotions, seasons, virtues, and generates reports specifically designed for the Christian community."
  },
  {
    id: "2",
    title: "Sacred Hours – Mobile App (Android)",
    video: sacredAndroidVideo,
    description : "Sacred Hours is a production Android application focused on Christian religious practices. The app provides daily devotions, traditional seasonal content, streak tracking, journaling notes, and virtues aligned with Christian traditions. All content is dynamically managed through the admin panel."
  },
  {
    id: "3",
    title: "Sacred Hours – Mobile App (IOS)",
    video: sacredIosVideo,
    description : "The Sacred Hours iOS application delivers the same core religious experience tailored for Apple users. It includes daily devotions, tradition-based seasons, streak tracking, journaling, and virtues, with real-time content updates from the admin system."
  },
  {
    id: "4",
    title: "Electricity Offers Platform – Multilingual Energy Products",
    video: energyVideo,
    description : "This project involves multiple production-based electricity offer websites for the same energy product, launched under different brand names and available in multiple languages, including English, French, and German. The platform ensures consistent pricing logic and offers across regions and languages."
  },
  {
    id: "5",
    title: "CRMHUB – Energy CRM & Reporting Platform",
    video: crmVideo,
    description : "CRMHUB is a production-based, customer-focused CRM platform designed for the US electricity market. The system manages multiple energy offers sourced from different partner websites and performs complex calculations to match offers with Kconnective standards. It includes multiple dashboards, reports, and pricing logic based on US energy regulations."
  },
  {
    id: "6",
    title: "GovDataLake – Government Intelligence Platform",
    video: govVideo,
    description : "GovDataLake is a government data intelligence platform similar to GovTribe, currently in the advanced development stage. The system aggregates data related to government agencies, opportunities, entities, and awards, enabling users to identify bidding opportunities and analyze entities for strategic decision-making."
  }
];